import * as actionType from '../action-type';

export const updateHardwoodDetailedReport = (data) => ({
  type: actionType.UPDATE_HARDWOOD_DETAILED_REPORT,
  payload: data,
});

export const resetHardwoodDetailedReport = () => ({
  type: actionType.RESET_HARDWOOD_DETAILED_REPORT,
});